module.exports = __webpack_public_path__ + "static/media/nativityScene.62666490.svg";